import { ConfirmContactSupport } from "@redotech/redo-agents-cards/support-agents/confirm-contact-support";
import * as z from "zod";
import { literal } from "zod";
import { ContentType } from "../../conversation";
import {
  AutoGeneratedFieldsSchema,
  BaseToolCallMessageSchema,
  WithoutId,
} from "../message-parser-utils";

const ContactSupportMessageSchema = BaseToolCallMessageSchema.extend({
  contentType: literal(ContentType.CONTACT_SUPPORT_UI),
  structuredContent: ConfirmContactSupport.optional(),
});
export const ContactSupportMessageDbParser = ContactSupportMessageSchema.merge(
  AutoGeneratedFieldsSchema,
);

export type ContactSupportMessageType = z.infer<
  typeof ContactSupportMessageDbParser
>;
export type ContactSupportMessageTypeWithoutId =
  WithoutId<ContactSupportMessageType>;

const collapseWhitespace = (text: string) => text.replace(/\s+/g, " ").trim();

/**
 * True when a text bubble repeats (whitespace-insensitive) the external-email
 * instructions an adjacent CONTACT_SUPPORT_UI message renders in its bubble.
 */
export function isRedundantExternalEmailInstructionsMessage(
  message: {
    readonly contentType?: string | null;
    readonly content?: string | null;
  },
  adjacentMessage:
    | {
        readonly contentType?: string | null;
        readonly structuredContent?: unknown;
      }
    | undefined,
): boolean {
  if (
    message.contentType !== ContentType.TEXT &&
    message.contentType !== ContentType.TOOL_CONFIRMATION_PROMPT
  ) {
    return false;
  }
  if (adjacentMessage?.contentType !== ContentType.CONTACT_SUPPORT_UI) {
    return false;
  }
  const content = message.content ? collapseWhitespace(message.content) : "";
  if (!content) {
    return false;
  }
  const parsed = ConfirmContactSupport.safeParse(
    adjacentMessage.structuredContent,
  );
  if (!parsed.success || !parsed.data.externalEmailMessage) {
    return false;
  }
  return collapseWhitespace(parsed.data.externalEmailMessage) === content;
}
